import React from 'react';

import MToastView from './MToast.view';

import { MToastProps } from './MToast.model';

type Props = MToastProps & {
  className?: string;
  proggressBarClassName?: string;
};

const MToast: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MToastView message={props.message} proggressBarClassName={props.proggressBarClassName} type={props.type} className={props.className}>
      {props.children}
    </MToastView>
  );
};

MToast.displayName = 'MToast';
MToast.defaultProps = {};

export default MToast;
